import { render, staticRenderFns } from "./LoanPlanInformation.vue?vue&type=template&id=ffaf2bce&scoped=true&"
import script from "./LoanPlanInformation.vue?vue&type=script&lang=js&"
export * from "./LoanPlanInformation.vue?vue&type=script&lang=js&"
import style0 from "./LoanPlanInformation.vue?vue&type=style&index=0&id=ffaf2bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaf2bce",
  null
  
)

export default component.exports